import React, { useEffect, useState, Fragment } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage/StandardPage'
import { ProductSearch } from './ProductSearch'
import { Filter } from '../../components/_WMS/FilterComponent'
import { defaultFilters } from './config'
import { getProductList, postExportSkuMasive } from './api'
import { Product, ProductoGrid } from './entities/Product'
import { ApiResponse } from '../../typings/ApiResponse'
import { useApi } from '../../hooks/useApi'
import { Status } from '../../hooks/useFetchState'
import { usePagination } from '../../hooks/usePagination'
import { GenericTable } from '../../components/_EOS/Table/GenericTable'
import { GenericOrderBy } from '../../components/_EOS/Table/types'
import { generateTableHeadersProduct } from '.'
import { useProductOrigins } from '../../hooks'
import { Modal } from '../../components/_EOS/Modal'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { useSnackbar } from '../../hooks/useSnackbar'
import { useModal } from '../../hooks/useModal'
import { Avatar, Box, IconButton, ListItemAvatar, Tooltip, Typography } from '@mui/material'
import { AddCircle, ListAlt, Download as DownloadIcon } from '@mui/icons-material'
import { CreateDun } from './Dun/CreateDun'
import { ViewProductov2 } from './ViewProducto/ViewProductov2'
import WarningIcon from '@mui/icons-material/Warning'
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import { VasRuleLogModal } from './modal/VasRuleLogModal'

interface ProductPageProps {}

export const NewProductPage: React.FC<ProductPageProps> = () => {
  type CustomActionsProps = {
    id: number
    row: Product
  }

  const [selectedFilters, setSelectedFilters] =
    React.useState<Filter[]>(defaultFilters)
  const { state, callApi } = useApi<ApiResponse<Product>>()
  const [selectedElement, setSelectedElement] = React.useState<string[]>([])
  const pagination = usePagination(5)
  const { isActive, isSuccess, message, openSnackBar } = useSnackbar()

  const { callApi: callApiExport, state: stateExport } = useApi()

  const requestProduct = (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => {
    callApi(getProductList(filters, page, pageSize)).catch((error) => {
      console.log(error)
    })
  }

  const handleRefreshGrid = () => {
    requestProduct(selectedFilters, pagination.page, pagination.pageSize)
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page

    setSelectedElement([])

    requestProduct(selectedFilters, auxPage, pageSize)

    pagination.setPagination(auxPage, pageSize)
  }

  const [orderBy] = useState<GenericOrderBy<Product>>({
    field: '',
    direction: 'desc'
  })

  useEffect(() => {
    pagination.setPagination(0, pagination.pageSize)

    requestProduct(selectedFilters, 0, pagination.pageSize)
  }, [orderBy])

  const {
    getProductOrigins,
    productOriginsState: { productOrigins }
  } = useProductOrigins()

  useEffect(() => {
    getProductOrigins()
  }, [])

  const tableHeadersProduct = generateTableHeadersProduct(productOrigins)

  const {
    isOpen: isOpenModalExportSku,
    closeModal: CloseModalExportSku,
    openModal: openModalExportSku
  } = useModal('Exportar')

  const productDunModal = useModal<{
    name: string
    sku: string
  }>('')

  const productViewModal = useModal<{
    item: Product
  }>('')

   const vasRuleLogModal = useModal<{ item: Product }>('Historial de Reglas VAS')

  const handledValidateExport = () => {
    const hasProductOriginId = selectedFilters.some(
      (filter) => filter.key === 'productOriginId'
    )

    if (!hasProductOriginId) {
      openSnackBar(`Seleccione filtro "Marca" para Exportar`, false)
      return
    }

    openModalExportSku()
  }

  const handleExportSku = () => {
      callApiExport(postExportSkuMasive(selectedFilters))
        .then(() => {
          CloseModalExportSku()
          openSnackBar(`Se agendo proceso correctamente`, true)
        })
        .catch((err) => {
          openSnackBar(`Error al agendar proceso`, true)
          console.log(err)
        })
    }

  const MyCustomActions: React.FC<CustomActionsProps> = ({ row }) => {
    return (
      <Fragment>
        <Tooltip title='Agregar DUN' aria-label='edit'>
          <IconButton
            aria-label='seeBinacle'
            onClick={() =>
              productDunModal.openModal(
                'lg',
                { name: row.name, sku: row.sku },
                'Gestionar DUN'
              )
            }
            style={{ verticalAlign: 'bottom' }}
          >
            <AddCircle />
          </IconButton>
        </Tooltip>
        <Tooltip title='Ver Detalle Producto' aria-label='edit'>
          <IconButton
            aria-label='seeBinacle'
            onClick={() => productViewModal.openModal('xl', { item: row })}
            style={{ verticalAlign: 'bottom' }}
          >
            <ListAlt />
          </IconButton>
        </Tooltip>
        <Tooltip title='Ver Logs Vas' aria-label='edit'>
          <IconButton
            aria-label='seeBinacle'
            onClick={() => vasRuleLogModal.openModal('lg', { item: row })}
            style={{ verticalAlign: 'bottom' }}
          >
            <WorkHistoryIcon />
          </IconButton>
        </Tooltip>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <StandardPage pageTitle=''>
        <ProductSearch
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onSearchClick={requestProduct}
          extraActions={[
            {
              label: 'Descargar catálogo',
              onClick: handledValidateExport,
              icon: <DownloadIcon />
            }
          ]}
        />

        <GenericTable<Product>
          headersConfig={tableHeadersProduct}
          IDKey={'id'}
          data={state.data?.items}
          pagination={{
            totalItem: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize
          }}
          onPaginationChange={handlePaginationChange}
          isLoading={state.status === Status.Loading}
          showCheckboxes={false}
          checkedElements={selectedElement}
          orderField={orderBy}
          customActionComponent={MyCustomActions}
        />
      </StandardPage>

      <Modal
        open={productDunModal.isOpen}
        onClose={productDunModal.closeModal}
        title={productDunModal.title}
        maxWidth={productDunModal.size}
      >
        <CreateDun
          nombreProducto={productDunModal.extendedProps?.name || ''}
          sku={productDunModal.extendedProps?.sku || ''}
          handleSnackbar={openSnackBar}
          handleCloseModal={productDunModal.closeModal}
        />
      </Modal>

      <Modal
        open={productViewModal.isOpen}
        onClose={productViewModal.closeModal}
        maxWidth='md'
        title='Detalle de Producto'
        cancelButton={{ action: productViewModal.closeModal, title: 'Cerrar' }}
      >
        <ViewProductov2
          elemento={productViewModal.extendedProps?.item as ProductoGrid}
          refreshGrid={() => handleRefreshGrid()}
        />
      </Modal>

      <Modal
        open={isOpenModalExportSku}
        maxWidth={'md'}
        onClose={CloseModalExportSku}
        title='¿Desea continuar con la descarga?'
        successButton={{
          action: () => handleExportSku(),
          title: 'Aceptar'
        }}
        cancelButton={{
          action: () => CloseModalExportSku(),
          title: 'Cancelar'
        }}
        loading={stateExport.status === Status.Loading}
      >
        <Box display='flex' alignItems='flex-start'>
          <ListItemAvatar>
            <Avatar>
              <WarningIcon />
            </Avatar>
          </ListItemAvatar>

          <Box>
            <Typography variant='body1'>
              La generación del archivo se realizará en segundo
              plano. Una vez solicitada, la descarga estará disponible en el
              menú de procesos.
            </Typography>

            <Typography
              variant='body1'
              color='textSecondary'
              style={{ marginTop: 8 }}
            >
              Si desea limitar los resultados, aplique los filtros antes de
              continuar. Este proceso puede tardar unos minutos.
            </Typography>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={vasRuleLogModal.isOpen}
        maxWidth={vasRuleLogModal.size}
        title={`Historial de Reglas VAS para SKU ${vasRuleLogModal.extendedProps?.item.sku || ''}`}
        onClose={() => {
          vasRuleLogModal.closeModal()
        }}
      >
        <VasRuleLogModal
          skuId={vasRuleLogModal.extendedProps?.item.id || 0}
        />
      </Modal>

      <SnackBar
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
        message={message}
      />
    </Fragment>
  )
}
